/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { withBrandIcon, type BrandIcon } from '../../../icons/with-brand-icon';

const OfficialIcon = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/launchdarkly" */ '@atlassian/logo-third-party/launchdarkly'
		).then((m) => m.LaunchdarklyIcon),
	{ moduleId: '@atlassian/logo-third-party/launchdarkly' },
);

const LazyLaunchDarklyIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-launchdarkly" */ './utils').then((m) => m.LaunchDarklyIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/launchdarkly/icon' },
);

const LazyLaunchDarklySearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-launchdarkly-search-result" */ './utils').then(
			(m) => m.LaunchDarklySearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/launchdarkly/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const LaunchDarklyIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyLaunchDarklyIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'small',
);

export const LaunchDarklySearchResultIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyLaunchDarklySearchResultIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'medium',
);
